export const Headline1 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '66px',
  lineHeight: '77px',
};

export const Headline2 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '42px',
  lineHeight: '49px',
};

export const Headline3 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '20px',
  lineHeight: '23px',
};

export const Headline4 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '20px',
  lineHeight: '23px',
};

export const Headline5 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '16px',
  lineHeight: '19px',
};

export const Headline6 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '16px',
  lineHeight: '19px',
};

export const Headline7 = {
  fontFamily: 'Mulish-Bold',
  fontSize: '14px',
  lineHeight: '16px',
};

export const Headline8 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '14px',
  lineHeight: '16px',
};

export const Headline9 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '14px',
  lineHeight: '16px',
};

export const Headline10 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '14px',
  lineHeight: '16px',
};

export const Headline11 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '14px',
  lineHeight: '14px',
};

export const Headline12 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '14px',
  lineHeight: '14px',
};

export const Headline13 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '16px',
  lineHeight: '14px',
};
export const Headline14 = {
  fontFamily: 'Mulish-Regular',
  fontSize: '16px',
  lineHeight: '12px',
};
export const Headline15 = {
  fontFamily: 'Mulish-Medium',
  fontSize: '16px',
  lineHeight: '12px',
};
